import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams, HttpResponse, HttpResponseBase } from '@angular/common/http';
//import { Headers, RequestOptions } from '@angular/common';
import { Player, Match, Tornament, UserTrace, Entry, Setting, Draw, Log, Team, AnEvent } from './Main.Model';
import { firstValueFrom, Observable } from "rxjs";
import { catchError, share, tap } from "rxjs/operators";
import { AlertService } from './alert.service';
import { ModalWindowComponent } from './modal/Modal-Window.component';
import {saveAs} from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class APIService {

  UserTrace!: UserTrace;//need to populate this and send with every call
  testResult!: Boolean;

  constructor(private http: HttpClient, private alertService: AlertService) { }

//   public async GetUserIp(Name, Torn) {
//     await this.http.get<UserTrace>('https://geolocation-db.com/json/').toPromise()
//       .then(data => {
//         this.UserTrace = data;
//     }).catch ((err: HttpErrorResponse) => {
//       this.alertService.showAlert("Getting IP Address", "Error", 'There was an error! while Getting IP Address', err)
//     })

//     // this.UserTrace.postal = Name;
//     // if (Torn) {
//     //   if (Torn.id) {
//     //     this.UserTrace.state = Torn.id;
//     //   } else {
//     //     this.UserTrace.state = 0;
//     //   }
//     // } else {
//     //   this.UserTrace.state = 0;
//     // }
// }

  public async Authenticate(Login: String, Password: string) {
    var Success = new Player();
    const headers = { 'content-type': 'application/json'}
    await this.http.post<Player>(`/api/Authenticate/${Login}/${Password}`, null).toPromise()
      .then(data => {
        Success = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("Authenticate", "Error", 'There was an error! while Authenticating', err)
    })
    return Success;
  }

  public async getSettings() {
    var Settings: Setting[] = [];
    await this.http.get<Setting[]>('/api/GetSettings').toPromise()
      .then(data => {
        Settings = data;
        //console.log("Settings retrieved :)");
    }).catch ((err: HttpErrorResponse) => {
      console.log(err);
      this.alertService.showAlert("getSettings", "Error", 'There was an error! while getSettings', err)
    })
    return Settings
  }

  public async  GetGalleryFolders() {
    var GalleryFolders: any[] = [];
    await this.http.get<any>('/api/GetGalleryFolders').toPromise()
      .then(data => {
        GalleryFolders = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("GetGalleryFolders", "Error", 'There was an error! while GetGalleryFolders', err)
    })
    return GalleryFolders
  }

  // public async GetVideoFolders() {
  //   var VideoFolders = [];
  //   await this.http.get<any>('/api/GetVideoFolders').toPromise()
  //     .then(data => {
  //       VideoFolders = data;
  //   }).catch ((err: HttpErrorResponse) => {
  //     this.alertService.showAlert("GetVideoFolders", "Error", 'There was an error! while GetVideoFolders', err)
  //   })
  //   return VideoFolders
  // }

  public async getPlayers() {
    var Players: Player[] = [];
    await this.http.get<Player[]>('/api/GetPlayers').toPromise()
      .then(data => {
        Players = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getPlayers()", "Error", 'There was an error! while Getting Players', err)
    })
    return Players
  }

  public async getMatchesForDraw(draw: Draw) {
    var Matches: Match[] = [];
     //const params = new HttpParams().set('criteria', criteria);
     const MatchSlotSize = this.getMatchCountForDraw(draw);
     let params = new HttpParams()
     .set('drawid', draw.id!.toString())
     .set('size', MatchSlotSize.toString());
    await this.http.get<Match[]>('/api/getMatchesForDraw', { params }).toPromise()
      .then(data => {
        Matches = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getMatchesForDraw()", "Error", 'There was an error! while getMatchesForDraw', err)
    })
    return Matches
  }

  public async getMatchesForTorn(TornId: number) {// not used ATM!!!
    var Matches: Match[] = [];
     let params = new HttpParams().set('TornId', TornId.toString());
    await this.http.get<Match[]>('/api/getMatchesForTorn', { params }).toPromise()
      .then(data => {
        Matches = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getMatchesForTorn()", "Error", 'There was an error! while getMatchesForTorn', err)
    })
    return Matches
  }

  public async getTeamsForTorn(TornId: number) {
    var Teams: Team[] = [];
     let params = new HttpParams().set('TornId', TornId.toString());
    await this.http.get<Team[]>('/api/getTeamsForTorn', { params }).toPromise()
      .then(data => {
        Teams = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getTeamsForTorn()", "Error", 'There was an error! while getTeamsForTorn', err)
    })
    return Teams
  }

  public async getAllMatches() {
    var Matches: Match[] = [];
    await this.http.get<Match[]>('/api/getAllMatches').toPromise()
      .then(data => {
        Matches = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getAllMatches()", "Error", 'There was an error! while getAllMatches', err)
    })
    return Matches
  }

  public async getTorns() {
    var Torns: Tornament[] = [];
    await this.http.get<Tornament[]>('/api/getTorns').toPromise()
      .then(data => {
        Torns = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getTorns", "Error", 'There was an error! while getTorns', err)
    })
    return Torns
  }

  public async getLogs() {
    var Logs: Log[] = [];
    await this.http.get<Log[]>('/api/getLogs').toPromise()
      .then(data => {
        Logs = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getLogs", "Error", 'There was an error! while getLogs', err)
    })
    return Logs
  }

  public async getErrorLogs() {
    var Logs: Log[] = [];
    await this.http.get<Log[]>('/api/getErrorLogs').toPromise()
      .then(data => {
        Logs = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getErrorLogs", "Error", 'There was an error! while getErrorLogs', err)
    })
    return Logs
  }

  public async GetTornsEntered(UserId: number) {
    var TornIds: number[] = [];
    await this.http.get<number[]>('/api/GetTornsEntered/' + UserId).toPromise()
      .then(data => {
        TornIds = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("GetTornsEntered", "Error", 'There was an error! while GetTornsEntered', err.toString())
    })
    return TornIds
  }

 public updateEntry(entry: Entry) {
  var EntryToUpdate = structuredClone(entry);
  EntryToUpdate.events = this.ConvertEventsArrayToString(entry.eventsList);//builds entry.Event string
  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updateEntry',EntryToUpdate, { headers, responseType: 'text' as 'json'}).subscribe({
    next: data => {
      console.log(data);
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Entry", "Error", 'There was an error! while updating entry for ' + entry.name, error.error)
    }
    })
 }

public updatePlayer(player: Player) {
  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updatePlayer', player, { headers, responseType: 'text' as 'json'}).subscribe({
      next: data => {
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Player", "Error", 'There was an error while updating player ' + player.name, error.error)
    }
  })
}

public updateTorn(torn: Tornament) {
  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updateTorn', torn, { headers, responseType: 'text' as 'json'}).subscribe({
      next: data => {
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Torn", "Error", 'There was an error while updating Torn ' + torn.name, error)
    }
  })
}

public updateMatch(match: Match) {
  const matchToSave = { ...match };//clones match object
  matchToSave.Winner = undefined;
  matchToSave.Loser = undefined;

  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updateMatch', matchToSave, { headers, responseType: 'text' as 'json'}).subscribe({
      next: data => {
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Match", "Error", 'There was an error while updating Match ' + matchToSave.id, error)
    }
  })
}

public updateDraw(draw: Draw) {
  const drawToSave = { ...draw };//clones draw object
  drawToSave.Matches = [];
  //drawToSave.events = [];
  drawToSave.theEvent = undefined;
  drawToSave.AvailablePlayers = [];
  drawToSave.Players1 = [];
  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updateDraw', drawToSave, { headers, responseType: 'text' as 'json'}).subscribe({
      next: data => {
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Draw", "Error", 'There was an error while updating Draw ' + drawToSave.id, error)
    }
  })
}

public async updateEvent(_event: AnEvent) {
  // if (_event.id == 0) {
  //   _event.id = await this.createNewEvent(_event);
  //   return _event.id
  // } else {
    const headers = { 'content-type': 'application/json'}
    this.http.post<string>('/api/updateEvent', _event, { headers, responseType: 'text' as 'json'}).subscribe({
        next: data => {
          return data
      },
      error: error => {
        this.alertService.showAlert("Updating Event", "Error", 'There was an error while updating Event ' + _event.name, error.error)
      }
    })
  //}
}

public async updateSetting(setting: Setting) {
  const headers = { 'content-type': 'application/json'}
  this.http.post<String>('/api/updateSetting', setting, { headers, responseType: 'text' as 'json'}).subscribe({
      next: data => {
      return data
    },
    error: error => {
      this.alertService.showAlert("Updating Setting", "Error", 'There was an error while updating Setting ' + setting.setting, error.error)
    }
  })
}

public SaveNewMatch(match: Match): Promise<Match> {
  //remove index 0 ONLY if it's not a Match
  return this.http
    .post<Match>('/api/SaveNewMatch', match)
    .toPromise();
}

// public async saveMatchCollection(matches: Match[]): Promise<Match[]> {
//   //remove index 0 ONLY if it's not a Match
//   if (matches.length > 0 && !this.isMatch(matches[0])) {
//     matches = matches.slice(1); // safer than shift()
//   }
//   const matchesToSave = matches.filter(m => m != null);

//   return this.http
//     .post<Match[]>('/api/SaveMatchCollection', matchesToSave)
//     .toPromise();
// }

public async saveMatchCollection(matches: Match[]): Promise<Match[]> {
    if (matches.length > 0 && !this.isMatch(matches[0])) {
        matches = matches.slice(1);
    }

    const matchesToSave = matches.filter(m => m != null);

    return await firstValueFrom(
        this.http.post<Match[]>('/api/SaveMatchCollection', matchesToSave)
    );
}


// public async SaveMatchCollection(matches: any[]): Promise<string> {

//   // remove index 0 ONLY if it's not a Match
//   if (matches.length > 0 && !this.isMatch(matches[0])) {
//     matches = matches.slice(1); // safer than shift()
//   }

//   const headers = { 'Content-Type': 'application/json' };

//   try {
//     const result = await this.http
//       .post('/api/SaveMatchCollection', matches, {
//         headers,
//         responseType: 'text'
//       })
//       .toPromise();

//     return result as string;

//   } catch (error: any) {
//     this.alertService.showAlert(
//       "Updating Matches",
//       "Error",
//       "There was an error while updating Matches",
//       error.error
//     );
//     throw error;
//   }
// }


// public SaveMatchCollection(matches) {
//   //const matchesToSave = matches.filter(m => m !== null);
//   //remove array index 0: - how can I only remove it if it is not a match object?
//   //remove object at array index 0 if it is not a match
//   if (matches.length > 0 && !matches[0].hasOwnProperty('dateOfMatch')) {
//     matches.shift();
//   }
//   const headers = { 'content-type': 'application/json'}
//   this.http.post<String>('/api/SaveMatchCollection', matches, { headers, responseType: 'text' as 'json'}).subscribe({
//       next: data => {
//       return data
//     },
//     error: error => {
//       this.alertService.showAlert("Updating Matches", "Error", 'There was an error while updating Matches', error.error)
//     }
//   })
// }

// public SaveMatchCollection(matches: Match[]) {
//   const matchesToSave = matches.filter(m => m !== null);

//   const headers = { 'Content-Type': 'application/json' };

//   this.http.post('/api/SaveMatchCollection', { matches: matchesToSave }, { headers, responseType: 'text' })
//     .subscribe({
//       next: data => console.log("Save result:", data),
//       error: error => this.alertService.showAlert(
//         "Updating Matches",
//         "Error",
//         'There was an error while updating Matches',
//         error.error
//       )
//     });
// }


public async createNewUser(player: Player) {
  var id = 0;
  await this.http.post<number>('/api/createNewUser', player).toPromise()
    .then(data => {
    id = data || 0;
  }).catch ((err: HttpErrorResponse) => {
    this.alertService.showAlert("createNewUser", "Error", 'There was an error! while createNewUser', err)
  })
  return id
}

public async createNewEvent(_event: AnEvent) {
  var id = 0;
  await this.http.post<number>('/api/createNewEvent', _event).toPromise()
    .then(data => {
    id = data || 0;
  }).catch ((err: HttpErrorResponse) => {
    this.alertService.showAlert("createNewEvent", "Error", 'There was an error! while createNewEvent', err)
  })
  return id
}

  public async createNewEntry(entry: Entry) {
    if (Array.isArray(entry.eventsList)) {//if events is array then convert to string
      entry.events = this.ConvertEventsArrayToString(entry.eventsList);
    }
    var id = 0;
    await this.http.post<number>('/api/createNewEntry', entry).toPromise()
      .then(data => {
      id = data || 0;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("createEntry", "Error", 'There was an error! while createEntry', err)
    })
    return id
  }

  public async createNewTorn(torn: Tornament) {
    var id = 0;
    await this.http.put<number>('/api/createNewTorn', torn).toPromise()
      .then(data => {
      id = data || 0;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("createNewTorn", "Error", 'There was an error! while createNewTorn', err)
    })
    return id
  }

  public async createNewDraw(draw: Draw) {
    var id = 0;
    await this.http.post<number>('/api/createNewDraw', draw).toPromise()
      .then(data => {
      id = data || 0;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("createNewDraw", "Error", 'There was an error! while createNewDraw', err)
    })
    return id
  }

  public async ChangePassword(id: number, old: string, newP: string):Promise<any> {//strings cannot be blank...
    var Success = "";
    const headers = { 'content-type': 'application/json'}
    await this.http.post<string>('/api/ChangePassword/' + id + '/' + old + '/' + newP, this.UserTrace, { headers, responseType: 'text' as 'json'}).toPromise()
      .then( data => {
        Success = data;
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("ChangePassword", "Error", 'There was an error! while ChangePassword', err)
      })
    return Success
  }

  public async RecoverPassword(Email: string): Promise<any> {
    var Success = "";
    const headers = { 'content-type': 'application/json'}
    await this.http.post<string>('/api/RecoverPassword/' + Email + '/', this.UserTrace, { headers, responseType: 'text' as 'json'}).toPromise()
    .then( data => {
      Success = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("RecoverPassword", "Error", 'There was an error! while RecoverPassword', err)
    })
  return Success
  }

  public async joinMailingList(Email: string): Promise<any> {
    var Success = "";
    const headers = { 'content-type': 'application/json'}
    await this.http.post<string>('/api/joinMailingList/' + Email + '/', this.UserTrace, { headers, responseType: 'text' as 'json'}).toPromise()
    .then( data => {
      Success = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("joinMailingList", "Error", 'There was an error! while joinMailingList', err)
    })
  return Success
  }

  public async PopulateTornArrays(Torn: Tornament) {
    //var BigTorn = new Tornament();
    //const headers = { 'content-type': 'application/json'}
    await this.http.get<Tornament>('/api/PopulateTornArrays/' + Torn.id + '/').toPromise()
    .then( data => {
      Torn.entries = data.entries;
      Torn.draws = data.draws;
      Torn.events = data.events;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("PopulateTornArrays", "Error", 'There was an error! while PopulateTornArrays', err)
    })
    return Torn
  }

  // public async populateDrawsMatches(draw) {
  //   const headers = { 'content-type': 'application/json'}
  //   await this.http.get<Draw>('/api/populateDrawsMatches/' + draw.id + '/').toPromise()
  //   .then( data => {
  //     draw.Matches = data.Matches
  //   }).catch ((err: HttpErrorResponse) => {
  //     this.alertService.showAlert("populateDrawsMatches", "Error", 'There was an error! while populateDrawsMatches', err)
  //   })
  //   return draw
  // }

  async fileUpload(files: FileList, dir: string) {
    //var files = event.target.files;
    const formData = new FormData();
    const fileToUpload = files[0] as File;
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('title',"Title");
    formData.append('directory',dir);
    var result;
    await this.http.post(`${"/api/uploadFile/"}`, formData).toPromise()
    .then( data => {
      result = data;
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("Uploading file", "Error", 'There was an error while uploading file ' + fileToUpload.name, err)
    })
  }

  public async SendAnnouncements(torn: Tornament, message: string):Promise<any> {//strings cannot be blank...
    torn.Message = message;
    var Success = "";
    const headers = { 'content-type': 'application/json'}
    await this.http.post<string>('/api/SendAnnouncements/' + torn, { headers, responseType: 'text' as 'json'}).toPromise()
      .then( data => {
        Success = data;
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("SendAnnouncements", "Error", 'There was an error! while Sending Announcements', err)
      })
    return Success
  }

  public async deleteEvent(_event: AnEvent) {
    var Result;
      await this.http.post('/api/deleteEvent/' + _event.id, null, { responseType: 'text'}).toPromise()
      .then( response => {
        Result = response
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("deleteEvent", "Error", 'There was an error! while deleteEvent', err)
      })
      return Result
  }

  public async deleteEntry(entry: Entry) {
    var Result: any;
      await this.http.post('/api/deleteEntry/' + entry.id, null).toPromise()
      .then( (response: any)  => {
        Result = response
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("deleteEntry", "Error", 'There was an error! while deleteEntry', err)
      })
      return Result
  }

  public async deleteTorn(torn: Tornament) {//THIS WORKS DON"T TOUCH!!!! - copy this method!!
    var Result: any;
      await this.http.post('/api/deleteTorn/' + torn.id,null).toPromise()
      .then( (response: any)  => {
        Result =  response
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("deleteTorn", "Error", 'There was an error! while deleteTorn', err)
      }
    )
    return Result
  }

  public async deleteDraw(draw: Draw) {
    var Result: any;
    await this.http.post('/api/deleteDraw/' + draw.id,null, { responseType: 'text'}).toPromise()
    .then( response => {
      Result = response
    }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("deleteDraw", "Error", 'There was an error! while deleteDraw', err)
      })
    return Result
  }

  public async deleteMatch(match: Match) {
    var Result;
    await this.http.post('/api/deleteMatch/' + match.id,null, { responseType: 'text'}).toPromise()
      .then( response => {
        Result = response
      }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("deleteMatch", "Error", 'There was an error! while deleteMatch', err)
      })
    return Result
  }

  public async RemoveMatchesFromDraw(draw: Draw) {
    var Result;
    await this.http.put('/api/RemoveMatchesFromDraw/' + draw.id,null, { responseType: 'text'}).toPromise()
    .then( response => {
      Result = response
    }).catch ((err: HttpErrorResponse) => {
        this.alertService.showAlert("RemoveMatchesFromDraw", "Error", 'There was an error! while RemoveMatchesFromDraw', err)
      })
    return Result
  }

  public async getFile(fileName: string) {
    var dir = "\\assets\\data\\";
    dir = dir.replace(/\\/g, "..");
    await this.http.get('/api/getFile/' + fileName + '/' + dir, {responseType: "blob"}).toPromise()
    .then( blob => {
      saveAs(blob, fileName);
    }).catch ((err: HttpErrorResponse) => {
      this.alertService.showAlert("getFile", "Error", 'There was an error! while getFile', err)
    })
  }

  ConvertEventsArrayToString(eventsArray: AnEvent[]) {
    var eventsString = '';
    eventsArray.forEach( anEvent => {
        eventsString = eventsString + anEvent.id
        if(anEvent.Partner) {
          eventsString = eventsString + '(' + anEvent.Partner.id + '),'
        } else {
          eventsString = eventsString + ','
        }
    });
    return eventsString;
    // if (entry.EventsEntered) {
    //   entry.events = '';//this should be a copy of torn.events....
    //   entry.fee = 0;
    //   entry.EventsEntered.forEach( anEvent => {
    //       if (anEvent.Entered == true) {
    //           if (anEvent.type == 'Doubles') {
    //               entry.events = entry.events + anEvent.id + '(' + anEvent.PartnerId + '),'
    //               entry.doublesMixed = true;
    //           } else {
    //               entry.events = entry.events + anEvent.id + ','
    //               entry.singles = true;
    //           }
    //           entry.fee = entry.fee + anEvent.cost;
    //       }
    //   })
    // }
  }

  getMatchCountForDraw(draw: Draw) {
    //determine match slot size based on draw size - as we need a match array with null for matches that never happened as there were not enough players
    var MatchSlotSize = 0;
    if (draw.format == "KO") {
      switch (draw.AvailablePlayers.length) {
        case 4:
          MatchSlotSize = 4;
          break;
        case 8:
          MatchSlotSize = 12;
          break;
        case 9:
        case 10:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
        case 16:
          MatchSlotSize = 32;
          break;  
        case 17:
        case 18:
        case 19:
        case 20:
        case 21:
        case 22:
        case 23:
        case 24:
        case 25:
        case 26:
        case 27:
        case 28:
        case 29:
        case 30:
        case 31:
        case 32:
          MatchSlotSize = 80;
          break;
        default:
          MatchSlotSize = 0;
          break;
      }
    }
    return MatchSlotSize;
  }

  private isMatch(obj: any): obj is Match {
    return obj &&
           typeof obj === 'object' &&
           'dateOfMatch' in obj &&
           'matchNo' in obj;
  }
  
}
